<template>
  <header id="page_header" :class="theme">
    <div class="grid-container">
        <div class="grid-x grid-margin-x">
            <div class="cell shrink">
                <a href="https://pravo.ru/" target="_blank" class="logo pravo"></a>
            </div>
            <div class="cell auto">
                <button type="button" v-if="theme == 'dark'" @click="overlayClose">На главную</button>
            </div>
            <div class="cell shrink">
                <a href="https://phplaw.ru/" target="_blank" class="logo hlyustov"></a>
            </div>
        </div>
    </div>
  </header>
</template>

<script>
export default {
    name: "Page_header",
    props: { theme: { default: "" } },
    data: () => ({}),
    methods: {
        overlayClose(){
            this.$root.$emit('hideOverlay')
        }
    }
};
</script>

<style lang="scss">
    #page_header {
        .cell {
            display:flex; align-content:center; justify-content:center;
        }
        .logo {
            display: inline-block; align-self:center;
            filter: drop-shadow(0.5px 0.5px 0.6px rgba(0, 0, 0, 0.8));

            &.pravo {
                background: url("~@/./assets/img/logo_pravo.png") no-repeat top left/100%;
                height: 20px;
                width: 120px;
            }
            &.hlyustov {
                background: url("~@/./assets/img/logo_hlyustov.png") no-repeat top
                    left/100%;
                height: 70px;
                width: 248px;
                float: right;
            }
        }

        &.dark {
            background:rgba(255,255,255,.9);
            .logo.pravo { filter:invert(1) }
        }

        button { text-transform:uppercase; font-family:$sans-serif; font-weight:bold; cursor:pointer }
    }
</style>